export default "__VITE_ASSET__BIXSljRv__"